import React from 'react';
import PropTypes from "prop-types";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';

const ChangePasswordMenu = props => {

    const { handleClose = fn => fn, open = false } = props;

    const [showNP, setShowNP] = React.useState(false);
  const [showCP, setShowCP] = React.useState(false);

  const handleClickShowNPassword = () => {
    const update = !showNP;
    setShowNP(update);
  };

  const handleClickShowCPassword = () => {
    const update = !showCP;
    setShowCP(update);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

    return (
        <div>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Change Password</DialogTitle>
                <DialogContent>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="newPassword"
                        label="New Password"
                        name="newPassword"
                        type={showNP ? "text" : "password"}
                        autoFocus
                        InputProps={{
                            endAdornment:
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowNPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        size="large">
                                        {showNP ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>

                        }}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="confirmPassword"
                        label="Confirm Password"
                        type={showCP ? "text" : "password"}
                        id="confirmPassword"
                        InputProps={{
                            endAdornment:
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowCPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        size="large">
                                        {showCP ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>

                        }}
                    />
                </DialogContent>
                <DialogActions style={{ justifyContent: 'center', padding: 20 }}>
                    <Button variant="contained" onClick={handleClose} color="primary">
                        Submit
          </Button>
                    <Button variant="outlined" onClick={handleClose} color="primary">
                        Cancel
          </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

ChangePasswordMenu.propTypes = {
    handleClose: PropTypes.func,
    open: PropTypes.bool
};


export default ChangePasswordMenu;